import priceListApi from '../../apis/priceList.api';
export default {
  state: {
    priceListResult: {
      carPrice: 0,
      carSubsidy: 0,
      needCost: null,
      commercialInsurance: null,
      loan: null,
      fullLandingPrice: 0,
    },
    specInfo: {
      SpecId: 0,
      SpecName: '',
      ImageUrl: '',
      MinPrice: 0,
      NewsPrice: 0,
    },
    resetInfo: {
      payType: 'full',
      prepaymentType: 1,
      loanTypeForYear: 3,
    },
    activity: [],
  },
  getters: {
    getpriceListResult(state) {
      return state.priceListResult;
    },
    getCarPrice(state) {
      return state.priceListResult.carPrice || 0;
    },
    getSpecInfo(state) {
      return state.specInfo;
    },
    getResetInfo(state) {
      return state.resetInfo;
    },
    getPayType(state) {
      return state.resetInfo.payType;
    },
  },
  actions: {
    getPriceListAction({ commit }, params) {
      priceListApi.getPriceList(params).then((data) => {
        commit('setPriceListResult', data);
      });
    },
  },
  mutations: {
    setSpecInfo(state, info) {
      state.specInfo = info;
    },
    setResetInfo(state, info) {
      state.resetInfo = info;
    },
    setPayType(state, type) {
      state.resetInfo.payType = type;
    },
    setCarPrice(state, value) {
      state.priceListResult.carPrice = value;
    },
    setPriceListResult(state, list) {
      state.priceListResult = list;
    },
    setActivity(state, list) {
      state.activity = list;
    },
  },
  namespaced: true,
};
